"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.areDefinedValuesEqual = exports.clearObject = void 0;
var lodash_1 = __importDefault(require("lodash"));
function clearObject(obj) {
    Object.keys(obj).forEach(function (key) { return delete obj[key]; });
}
exports.clearObject = clearObject;
/**
 * Checks if two objects are equal while ignoring undefined values
 * E.g. returns true for the following two arguments
 *
 *  a = { first: 'first', second: undefined }
 *  b = { first: 'first' }
 */
function areDefinedValuesEqual(a, b) {
    a = removeUndefinedValues(a);
    b = removeUndefinedValues(b);
    return lodash_1.default.isEqual(a, b);
}
exports.areDefinedValuesEqual = areDefinedValuesEqual;
function removeUndefinedValues(val) {
    if (lodash_1.default.isObject(val)) {
        return lodash_1.default.omitBy(val, lodash_1.default.isUndefined);
    }
    return val;
}
